import { stringUtil } from "@sdeapps/react-core";
import { createFilterOptions } from "@mui/material";
import type { FilterOptionsState } from "@mui/material";
import type { Antenne, Commune } from "models";

function filterOptions<T extends { libelle: string }>(): (
  options: Array<T>,
  state: FilterOptionsState<T>
) => Array<T> {
  return createFilterOptions<T>({
    trim: true,
    stringify: (option) => stringUtil.normalize(option.libelle),
  });
}

export const filterOptionsAntenne = filterOptions<Antenne>();
export const filterOptionsCommune = filterOptions<Commune>();

export function isOptionEqualToValue<T extends { id: string }>(option1: T, option2: T): boolean {
  return option1.id === option2.id;
}

export function getOptionKey<T extends { id: string }>(option: T): string {
  return option.id;
}

export function getOptionLabel<T extends { libelle: string }>(option: T): string {
  return option.libelle;
}
